import React, { ReactNode } from 'react';
interface IGridProps {
    children: ReactNode;
}

export const Grid: React.FC<IGridProps> = ({ children }) => (
    //@ts-ignore
    <dsd-grid>{children}</dsd-grid>
);
